import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-select/dist/vue-select.css";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueClipboard from "vue-clipboard2";
import { VueMasonryPlugin } from "vue-masonry";
import vSelect from "vue-select";
import store from "./store";
import i18n from "./i18n";
import { formatCurrency } from "./misc/LocaleFormat";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import Default from "./layouts/Default";
import Partial from "./layouts/Partial";

import tinymce from "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/skins/ui/oxide/content.inline.css";
import "tinymce/themes/silver";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/advlist";
import "./assets/fonts.css";

const defaultOptions = {
  inline: true,
  plugins: "table lists link image advlist",
  menubar: false,
  skin: false,
  toolbar:
    "undo redo formatselect bold italic underline fontsizeselect fontselect numlist bullist table forecolor backcolor link unlink image alignleft aligncenter alignright alignjustify indent outdent",
  theme_advanced_blockformats: "p,h1,h2,h3,h4,h5,h6",
  image_list: [
    { title: "Dog", value: "https://via.placeholder.com/150" },
    { title: "Cat", value: "https://via.placeholder.com/150" },
  ],
};

Vue.component("v-select", vSelect);
Vue.directive("tinymce", {
  bind(el, { value }, node) {
    setTimeout(function () {
      if (value.editable) {
        tinymce.init({
          target: el,
          table_resize_bars: false,
          init_instance_callback: function (editor) {
            if (!node.data.on) return;
            if (node.data.on["mce-change"]) {
              let handler = node.data.on["mce-change"];
              handler
                ? ["Blur", "Keyup", "Click", "Dirty", "ExecCommand"].forEach(
                    (eventName) =>
                      editor.on(eventName, (e) => handler.fns(el.innerHTML))
                  )
                : null;
            }
            if (node.data.on["mce-dirty"]) {
              let handler = node.data.on["mce-dirty"];
              editor.on("Dirty", (e) => handler.fns(el.innerHTML));
            }
          },
          ...defaultOptions,
          ...value,
        });
      }
    }, 300);
  },
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VueClipboard);
Vue.use(VueMasonryPlugin);
Vue.filter("currency", (value) => formatCurrency(value, i18n.locale));

Vue.config.productionTip = false;
Vue.component("default-layout", Default);
Vue.component("partial-layout", Partial);

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
